<!-- static content data from lang: user_management -->
<template>
  <div>
    <div v-loading="loading">
      <base-header class="pb-6">
        <div class="row align-items-center pb-4">
          <div class="col-lg-12 col-12">
            <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.headerTitle}}</h6>
            <nav aria-label="breadcrumb" class="d-inline-block ml-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </div>
        </div>
      </base-header>
      <div class="container-fluid mt--6">
        <div>
          <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
            <div class="col-md-12">
              <template v-for="(message) in alertMessages">
                <Alert :type = alertType dismissible  v-if="message" :key="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <template v-for="(message) in successMessages">
                <Alert :type = successType dismissible  v-if="message" :key="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <template v-if="notVerified">
                    <base-input alternative
                                :label="lang.label.passport"
                                labelClasses="form-control-label asterisk-mark"
                                class="mb-3"
                                name="ID/Passport"
                                rules="required"
                                prepend-icon="ni ni-single-02"
                                :placeholder="lang.label.passport + '*'"
                                v-model="model.userName"
                                autocomplete="off">
                    </base-input>
                    <div class="text-right mb-3">
                      <base-button type="primary" native-type="submit">{{lang.label.buttons.continue}}</base-button>
                    </div>
                  </template>
                  <template v-else>
                    <base-input
                      alternative
                      :label="lang.label.passport"
                      labelClasses="form-control-label asterisk-mark"
                      class="mb-3"
                      name="ID/passport"
                      rules="required"
                      prepend-icon="ni ni-single-02"
                      :placeholder="lang.label.passport + '*'"
                      v-model="model.userName"
                      autocomplete="off"
                      :disabled="!notVerified"
                    ></base-input>
                    <base-input
                      alternative
                      :label="lang.label.name"
                      labelClasses="form-control-label asterisk-mark"
                      class="mb-3"
                      name="name"
                      rules="required"
                      prepend-icon="fas fa-user-circle"
                      :placeholder="lang.label.name + '*'"
                      v-model="model.name"
                      autocomplete="off"
                    ></base-input>
                    <base-input
                      alternative
                      :label="lang.label.surname"
                      labelClasses="form-control-label asterisk-mark"
                      class="mb-3"
                      name="surname"
                      rules="required"
                      prepend-icon="far fa-user-circle"
                      :placeholder="lang.label.surname + '*'"
                      v-model="model.surname"
                      autocomplete="off"
                    ></base-input>
                    <base-input
                      alternative
                      :label="lang.label.emailAddress"
                      class="mb-3"
                      name="email address"
                      rules="email"
                      prepend-icon="ni ni-email-83"
                      :placeholder="lang.label.emailAddress + '*'"
                      v-model="model.emailAddress"
                      autocomplete="off"
                    ></base-input>
                    <base-input
                      alternative
                      :label="lang.label.phoneNumber"
                      labelClasses="form-control-label asterisk-mark"
                      class="mb-3"
                      name="cell phone number"
                      :rules="{required: true, numeric: true, digits: '10'}"
                      prepend-icon="ni ni-mobile-button"
                      :placeholder="lang.label.phoneNumber + '*'"
                      @input="copyToWhatsAppNumber"
                      @keypress="isNumber($event)"
                      v-model="model.phoneNumber"
                      autocomplete="off"
                    ></base-input>
                    <base-input
                      alternative
                      :label="lang.label.WhatsAppNumber"
                      labelClasses="form-control-label asterisk-mark"
                      class="mb-3"
                      name="whatsApp number"
                      :rules="{required: true, numeric: true, digits: '10'}"
                      prepend-icon="fab fa-whatsapp"
                      :placeholder="lang.label.WhatsAppNumber + '*'"
                      @keypress="isNumber($event)"
                      v-model="model.WhatsAppNumber"
                      autocomplete="off"
                    ></base-input>
                    <div class="form-group">
                      <base-input
                        :label="lang.label.communicationType"
                        labelClasses="form-control-label asterisk-mark"
                        name="communication type"
                        :rules="{required: true}"
                      >
                        <b-form-group class="mb-0">
                          <b-form-radio-group
                            id="radio-options"
                            v-model="model.communication"
                            autocomplete="off"
                            :options="communicationType"
                            name="radio-options"
                          ></b-form-radio-group>
                        </b-form-group>
                      </base-input>
                    </div>
                    <div class="form-group">
                      <base-input
                        :label="lang.label.addGroups"
                        name="photo change option"
                        :rules="{required: true}"
                      >
                        <b-form-group class="mb-0">
                          <b-form-radio-group
                            id="add-group"
                            v-model="addGroups"
                            autocomplete="off"
                            :options="options"
                            name="add-group"
                          ></b-form-radio-group>
                        </b-form-group>
                      </base-input>
                    </div>
                    <div class="form-group" v-if="imageUrl">
                      <base-input
                        :label="lang.label.changeLogo"
                        name="photo change option"
                        :rules="{required: true}"
                      >
                        <b-form-group class="mb-0">
                          <b-form-radio-group
                            id="photo-change"
                            v-model="change"
                            autocomplete="off"
                            :options="options"
                            name="photo-change"
                          ></b-form-radio-group>
                        </b-form-group>
                      </base-input>
                    </div>
                    <div class="form-group photo-upload">
                      <div class="row">
                        <div class="col-2" v-if="imageUrl ? change == 'Yes' : true">
                      <base-input
                        :label="lang.label.uploadPhoto"
                      >
                        <vue-dropzone
                          ref="myVueDropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          class="textFile"
                          v-model="model.photo"
                          autocomplete="off"
                          @vdropzone-file-added="filesAdded"
                          @vdropzone-success="fileSuccess"
                          @vdropzone-removed-file="filesRemoved"
                        ></vue-dropzone>
                      </base-input>
                    </div>
                        <div class="col-4 pt-4 pl-0">
                          <img  v-if="!fileAdded && imageUrl" height="150px" :src="imageUrl" alt="company logo">
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <base-input
                        :label="model.allowShareInformation == '1' ? lang.label.allowShareInformation : lang.label.notAllowedShareInformation"
                        name="share information"
                        :rules="{required: true}"
                      >
                        <b-form-group class="mb-0">
                          <b-form-radio-group
                            id="radio-group1"
                            v-model="model.allowShareInformation"
                            autocomplete="off"
                            :options="allowShareInformation"
                            name="radio-options1"
                          ></b-form-radio-group>
                        </b-form-group>
                      </base-input>
                    </div>
                    <div class="text-center">
                      <base-button
                        type="primary"
                        native-type="submit"
                        class="mt-3"
                        :disabled="uploading"
                      >{{lang.label.buttons.submit}}</base-button>
                    </div>
                  </template>
                </form>
              </validation-observer>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { Select, Option } from "element-ui";
    import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
    import Alert from "@/components/BaseAlert.vue";
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import state from "../../../store/state";
    import {mapGetters} from "vuex";

    export default {
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            RouteBreadCrumb,
            Alert,
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                photosAdded: [],
                alertType: 'danger',
                successType: 'success',
                alertMessages: [],
                successMessages: [],
                change: 'No',
                addGroups: 'No',
                options: [
                    { text: "Yes", value: "Yes" },
                    { text: "No", value: "No" }
                ],
                imageUrl: '',
                visitorId: null,
                fileAdded: false,
                lang: this.$lang.visitor_management,
                notVerified: true,
                loading: false,
                uploading: false,
                model: {
                    userName: "",
                    name: "",
                    surname: "",
                    emailAddress: "",
                    phoneNumber: "",
                    WhatsAppNumber: "",
                    communication: [],
                    allowShareInformation: "1",
                    photo: ""
                },
                otherInfo: {
                    name: [],
                    relation: [],
                    photo: []
                },
                communicationType: [
                    { text: "Email", value: "1" },
                    { text: "SMS", value: "2" },
                    // { text: "WhatsApp", value: "3" }
                ],
                allowShareInformation: [
                    { text: "Yes", value: "1" },
                    { text: "No", value: "0" },
                ],
                dropzoneOptions: {
                    url: "https://httpbin.org/post",
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    uploadMultiple: false,
                    maxFilesize: 10,
                    maxFiles: 1,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    dictDefaultMessage:
                        "<div class='upload-docs'><p>Drop file here <br/>or <br/>click to upload</p></div>"
                },
                companyName: [],
                siteName: [],
                selects: {
                    simple: "Select"
                },
                roles: [
                    {text: 'Administrator', value: 'Administrator', disabled: false},
                    {text: 'Company Admin', value: 'Company Admin', disabled: false},
                    {text: 'Site Admin', value: 'Site Admin', disabled: false},
                    {text: 'Approve Access', value: 'Approve Access', disabled: true},
                    {text: 'Visitor Questionnaires Access', value: 'Visitor Questionnaires Access', disabled: true},
                    {text: 'Report Access', value: 'Report Access', disabled: true},
                ],
                selected: [],
            };
        },
        watch: {
            selected(val,oldVal) {
                if (val.includes("Site Admin") && !oldVal.includes("Company Admin")) {
                    let temp = [0, 1];
                    if (!val.includes("Approve Access")) {
                        this.selected.push("Approve Access")
                    }
                    if (!val.includes("Visitor Questionnaires Access")) {
                        this.selected.push("Visitor Questionnaires Access")
                    }
                    if (!val.includes("Report Access")) {
                        this.selected.push("Report Access")
                    }
                    this.disableOthers(temp, true);
                } else {
                    if (val.includes("Administrator")) {
                        if (!val.includes("Report Access")) {
                            this.selected.push("Report Access")
                        }
                        let temp = [1, 2];
                        this.disableOthers(temp, true);
                    } else if (!val.includes("Company Admin")) {
                        if (val.includes("Report Access")) {
                            this.selected.splice(this.selected.indexOf("Report Access"), 1)
                        }
                        let temp = [1, 2];
                        this.disableOthers(temp, false);
                    }
                    if (val.includes("Company Admin")) {
                        if (!val.includes("Site Admin")) {
                            this.selected.push("Site Admin")
                        }
                        if (!val.includes("Approve Access")) {
                            this.selected.push("Approve Access")
                        }
                        if (!val.includes("Visitor Questionnaires Access")) {
                            this.selected.push("Visitor Questionnaires Access")
                        }
                        if (!val.includes("Report Access")) {
                            this.selected.push("Report Access")
                        }
                        let temp = [0, 2];
                        this.disableOthers(temp, true);
                    } else if (!val.includes("Administrator")) {
                        if (val.includes("Site Admin")) {
                            this.selected.splice(this.selected.indexOf("Site Admin"), 1)
                        }
                        if (val.includes("Approve Access")) {
                            this.selected.splice(this.selected.indexOf("Approve Access"), 1)
                        }
                        if (val.includes("Visitor Questionnaires Access")) {
                            this.selected.splice(this.selected.indexOf("Visitor Questionnaires Access"), 1)
                        }
                        let temp = [0, 2];
                        this.disableOthers(temp, false);
                    }
                }

            }
        },
        computed:{
            ...mapGetters({
                login: "login",
                prevPage: "prevPage",
                disqualified: "disqualified",
                formID: "formID",
            })
        },
        mounted() {
            let self = this;
            this.$store.commit('setFormID', null);
            localStorage.removeItem('formID');
            if(this.disqualified && this.disqualified.includes('Based')) {
                self.alertMessages.push(this.disqualified);
            }else{
                self.successMessages.push(this.disqualified);
            }
            if(this.disqualified){
                setTimeout(function () {
                    self.alertMessages = [];
                    self.successMessages = [];
                    self.$store.commit('setDisqualified','');
                },5000)
            }
        },
        methods: {
            isNumber: function (index, evt,flag = false) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                }
            },
            copyToWhatsAppNumber(){
                this.model.WhatsAppNumber = this.model.phoneNumber;
            },
            filesAdded(file){
                // this.observeFiles();
                this.fileAdded = true;
                this.uploading = true;
            },
            fileSuccess: function (file) {
                this.uploading = false;
            },
            observeFiles(){
            },
            filesRemoved: function(file,error){
                // this.observeFiles();
                this.fileAdded = false;
                this.uploading = false;
            },
            disableOthers(data, flag) {
                let newRoles = this.roles;
                newRoles.forEach((object, index) => {
                    if(flag){
                        if(this.selected.includes(object.value)){
                            this.roles[index].disabled = false;
                        }else{
                            this.roles[index].disabled = true;
                        }
                    }else{
                        if (data.includes(index)) {
                            this.roles[index].disabled = flag;
                        }
                        if (index > 2){
                            this.roles[index].disabled = true;
                        }
                    }
                });
            },
            onSubmit() {
                let self = this;
                this.loading = true;
                if(this.notVerified){
                    this.$refs.formValidator.reset();
                    let data = this.model.userName;
                    this.$store
                        .dispatch("getVisitor", data)
                        .then(response => {
                                if (response.status  == 200) {
                                    self.$store.commit('setFormID', response.data.QuestionnaireID);
                                    self.model.userName = response.data.Username;
                                    self.model.name = response.data.Name;
                                    self.model.surname = response.data.Surname;
                                    self.model.emailAddress = response.data.EmailAddress ? response.data.EmailAddress : '';
                                    self.model.phoneNumber = response.data.CellphoneNumber;
                                    self.model.WhatsAppNumber = response.data.WhatsAppNumber;
                                    self.model.communication = response.data.CommsPrefType;
                                    if(self.login.AllowShareInformation !== undefined && self.login.AllowShareInformation !== null) {
                                        self.model.allowShareInformation = response.data.AllowShareInformation ? 1: 0;
                                    }
                                    self.visitorId = response.data.QuestionnaireID;
                                    if(response.data.Photograph){
                                        self.imageUrl = state.mediaURL + response.data.Photograph;
                                    }
                                    self.notVerified = false;
                                }else{
                                    if(typeof response.data.message != 'object'){
                                        this.alertMessages.push(response.data.message);
                                        setTimeout(function () {
                                            self.alertMessages = [];
                                        },5000)
                                    }else{
                                        var array = new Array();
                                        for (let key of Object.keys(response.data.message)) {
                                            let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                            array.push(obj)
                                        }
                                        this.alertMessages.push(array.join(', '));
                                        setTimeout(function () {
                                            self.alertMessages = [];
                                        },5000)
                                    }
                                }
                              self.loading = false;
                        })
                }else{
                    let formData = new FormData();
                    formData.append('Username', this.model.userName);
                    formData.append('Name', this.model.name);
                    formData.append('Surname', this.model.surname);
                    formData.append('EmailAddress', this.model.emailAddress ? this.model.emailAddress : '');
                    formData.append('CellphoneNumber', this.model.phoneNumber);
                    formData.append('WhatsAppNumber', this.model.WhatsAppNumber);
                    formData.append('CommsPrefType', this.model.communication);
                    formData.append('AllowShareInformation', this.model.allowShareInformation);
                    if(this.change == "Yes" || !this.imageUrl){
                        let imageFiles =  this.$refs.myVueDropzone.dropzone.files;
                        imageFiles.forEach((object) => {
                            formData.append('Photograph', object);
                        });
                    }
                    this.$store.dispatch('signUp',formData).then(response =>{
                        this.loading = false;
                        if(response.status == 200) {
                            self.$store.commit('setVisitorId', response.data.ID);
                            console.log( response.data.ID,'formID');
                            self.$store.commit('setPrevPage', true);
                            if(self.addGroups == 'Yes') {
                                self.$store.commit('setAddGroups', true);
                                self.$router.push({name: "addGroupManagement"});
                            }else {
                                self.$store.commit('setAddGroups', false);
                                self.$router.push({name: "visitor", params: {id: self.formID}});
                            }
                        }else{
                            if(typeof response.data.message != 'object'){
                                this.alertMessages.push(response.data.message);
                                setTimeout(function () {
                                    self.alertMessages = [];
                                },5000)
                            }else{
                                var array = new Array();
                                for (let key of Object.keys(response.data.message)) {
                                    let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                    array.push(obj)
                                }
                                this.alertMessages.push(array.join(', '));
                                setTimeout(function () {
                                    self.alertMessages = [];
                                },5000)
                                self.loading = false;
                            }
                        }
                    });
                }

            },
        },
    };
</script>
<style>
  .no-border-card .card-footer {
    border-top: 0;
  }
  .modal-header {
    padding-bottom: 0;
  }
</style>
